import { render, staticRenderFns } from "./AssetListItem.vue?vue&type=template&id=3562bde8&scoped=true"
import script from "./AssetListItem.vue?vue&type=script&lang=ts"
export * from "./AssetListItem.vue?vue&type=script&lang=ts"
import style0 from "./AssetListItem.vue?vue&type=style&index=0&id=3562bde8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562bde8",
  null
  
)

export default component.exports